import PollAPI from "api/PollAPI";
import useFetchData from "hooks/useFetchData";

export default function usePollsUnfilled() {
   return useFetchData({
      APIMethod: PollAPI.getUnfilled
   })
}